import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { pvJahresvergleich } from '../components/objects/pvJahresvergleich';
import PvDashboard from '../components/PvJahresvergleich/PvDashboard';
import FilterBar from '../components/PvJahresvergleich/FilterBar';
import EmptyState from '../components/PvJahresvergleich/FehlerLeerstand';
import { PvSkeletonLoader } from '../components/PvJahresvergleich/SkeletonLoader';

class PvJahresvergleichClass extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        return null;
    }

    state = { _fetchNeeded: false };

    componentDidMount() {
        this.setState({}, () => {
            pvJahresvergleich.PvJahresvergleichClass.url =
                pvJahresvergleich.PvJahresvergleichClass.defaultSegment + '/1';
            pvJahresvergleich.PvJahresvergleichClass.forceRefresh = true;
            this.props.request(pvJahresvergleich['PvJahresvergleichClass']);
        });
    }

    componentDidUpdate(prevProps) {
        // Wenn neue Jahresvergleich-Daten da sind, Soll-vs-Ist fuer das neueste Jahr laden
        var prevUi = prevProps.PvJahresvergleichUI;
        var currUi = this.props.PvJahresvergleichUI;
        if (currUi && currUi.jahreswerte && (!prevUi || !prevUi.jahreswerte ||
            currUi.jahreswerte.length !== prevUi.jahreswerte.length)) {
            // Bestimme das letzte vollstaendige Jahr
            var letztesJahr = currUi.jahreswerte
                .filter(function (j) { return j.inTrendEnthalten; })
                .sort(function (a, b) { return b.jahr - a.jahr; })[0];

            if (letztesJahr) {
                this.ladeSollVsIst(letztesJahr.jahr);
            }
        }
    }

    handleFilterChange(newStart, newEnd) {
        let url = pvJahresvergleich.PvJahresvergleichClass.defaultSegment + '/1';
        var queryParts = [];
        if (newStart != null && !isNaN(newStart)) {
            queryParts.push('startYear=' + newStart);
        }
        if (newEnd != null && !isNaN(newEnd)) {
            queryParts.push('endYear=' + newEnd);
        }
        if (queryParts.length > 0) {
            url += '?' + queryParts.join('&');
        }

        pvJahresvergleich.PvJahresvergleichClass.url = url;
        pvJahresvergleich.PvJahresvergleichClass.forceRefresh = true;
        this.props.request(pvJahresvergleich['PvJahresvergleichClass']);
    }

    handleRefresh() {
        pvJahresvergleich.PvJahresvergleichClass.forceRefresh = true;
        this.props.request(pvJahresvergleich['PvJahresvergleichClass']);
        // Auch Soll-vs-Ist neu laden, falls bereits geladen
        if (this.props.SollVsIstUI) {
            this.ladeSollVsIst(this.props.SollVsIstUI.jahr);
        }
    }

    /** Soll-vs-Ist Daten fuer ein bestimmtes Jahr ueber Redux laden */
    ladeSollVsIst(jahr) {
        pvJahresvergleich.SollVsIstClass.url =
            pvJahresvergleich.SollVsIstClass.defaultSegment + '/1/sollVsIst?jahr=' + jahr;
        // WICHTIG: forceRefresh NICHT setzen! requestStartType fuehrt im Reducer
        // zu PvJahresvergleichUI=null und isLoaded=false.
        pvJahresvergleich.SollVsIstClass.forceRefresh = false;
        this.props.request(pvJahresvergleich['SollVsIstClass']);
    }

    render() {
        return (
            <div>
                {this.renderContent()}
            </div>
        );
    }

    renderContent() {
        const ui = this.props.PvJahresvergleichUI;
        const isLoaded = this.props.isLoaded;
        const loading = !isLoaded;

        // Ladezustand: Skeletons anzeigen statt leerer Seite
        if (loading) {
            return <PvSkeletonLoader />;
        }

        if (!ui) {
            return (
                <EmptyState
                    state="fehler"
                    message='Keine Daten empfangen.'
                    onRetry={this.handleRefresh.bind(this)}
                />
            );
        }

        // Antwortstatus prüfen
        const AntwortStatus = ui.status;
        const isEmptyData = AntwortStatus === 1;   // KEINE_DATEN
        const isTooFewYears = AntwortStatus === 2;  // ZU_WENIGE_JAHRE

        if (isEmptyData) {
            return (
                <EmptyState
                    state="keineDaten"
                    message={ui.fehlermeldung || 'Keine historischen Ertragsdaten vorhanden.'}
                    onRetry={this.handleRefresh.bind(this)}
                />
            );
        }

        if (isTooFewYears && !ui.jahreswerte) {
            return (
                <EmptyState
                    state="zuWenigeJahre"
                    message={ui.fehlermeldung || 'Nicht genügend Daten für die Analyse.'}
                    onRetry={this.handleRefresh.bind(this)}
                />
            );
        }

        // Alle Jahre aus den Daten extrahieren (für FilterBar)
        const allYears = ui.jahreswerte
            ? ui.jahreswerte.map((item) => item.jahr)
                .filter((v, i, arr) => arr.indexOf(v) === i)
                .sort((a, b) => a - b)
            : [];

        return (
            <div className="pv-jahresvergleich">
                {/* Zeitraum-Filter */}
                {allYears.length >= 2 && (
                    <FilterBar
                        allYears={allYears}
                        startYear={this.props.startYear || allYears[0]}
                        endYear={this.props.endYear || allYears[allYears.length - 1]}
                        onFilterChange={this.handleFilterChange.bind(this)}
                    />
                )}

                {/* Dashboard */}
                <PvDashboard
                    data={ui}
                    onRefresh={this.handleRefresh.bind(this)}
                    emptyState={isTooFewYears ? ui : null}
                    sollVsIstData={this.props.SollVsIstUI}
                    verfuegbareJahre={allYears}
                    onLoadSollVsIst={this.ladeSollVsIst.bind(this)}
                />
            </div>
        );
    }
}

export default connect(
    state => state.pvJahresvergleichReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(PvJahresvergleichClass);
